var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.167 32.7084H20.8337C17.792 32.7084 16.042 30.9584 16.042 27.9167V22.0834C16.042 19.0417 17.792 17.2917 20.8337 17.2917H29.167C32.2087 17.2917 33.9587 19.0417 33.9587 22.0834V27.9167C33.9587 30.9584 32.2087 32.7084 29.167 32.7084ZM20.8337 18.5417C18.4503 18.5417 17.292 19.7 17.292 22.0834V27.9167C17.292 30.3 18.4503 31.4584 20.8337 31.4584H29.167C31.5503 31.4584 32.7087 30.3 32.7087 27.9167V22.0834C32.7087 19.7 31.5503 18.5417 29.167 18.5417H20.8337Z",
    fill: "#514EF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.725C24.3 25.725 23.5916 25.5083 23.05 25.0666L20.4416 22.9833C20.175 22.7666 20.125 22.375 20.3416 22.1083C20.5583 21.8416 20.95 21.7916 21.2166 22.0083L23.825 24.0916C24.4583 24.6 25.5333 24.6 26.1666 24.0916L28.775 22.0083C29.0416 21.7916 29.4416 21.8333 29.65 22.1083C29.8666 22.375 29.825 22.775 29.55 22.9833L26.9416 25.0666C26.4083 25.5083 25.7 25.725 25 25.725Z",
    fill: "#514EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit-blue.3adc3ad89dd6964f9ce9fb1248a0be90.svg";
export { ForwardRef as ReactComponent };